module.exports = __webpack_public_path__ + "img/664dd2e.png";